import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
export const getListRowsSchema = z.array(
  baseObjectSchema.extend({
    qstListId: z.string(),
    description: z.string(),
    image: z.string().optional(),
    sort: z.number(),
  })
);
export type GetDeliveryTypesResponse = z.infer<typeof getListRowsSchema>;
